import React, { Component } from "react";

import { padZero } from '../../utils/format';

class Timer extends Component {

    constructor(props) {
        super(props);
        this.updateTime = this.updateTime.bind(this);
        this.state = {
            timeString: '',
        }
    }

    updateTime() {
        const {
            endTime, // js date
        } = this.props;
        const diffSeconds = (endTime - Date.now()) / 1000 | 0;
        const diffMinutes = ((diffSeconds / 60) | 0);
        const diffMinutesMod = diffMinutes % 60;
        const diffHours = (diffMinutes / 60) | 0;
        const timeString = `${diffHours}hrs ${padZero(diffMinutesMod, 2)}min`;

        this.setState({ timeString });
    }

    componentDidMount() {
        this.updateTime();
        this.setState({ interval: setInterval(this.updateTime.bind(this), 1000) });
    }

    componentWillUnmount() {
        const {
            interval,
        } = this.state;

        clearInterval(interval);
        this.setState({ interval: null })
    }

    render() {
        const {
            timeString
        } = this.state;

        return (
            <div className="nav-timer">
                <div className="nav-timer-label">
                    TIME REMAINING
                </div>
                <div className="nav-timer-counter">
                    {timeString}
                </div>
            </div>
        );
    }
}

export default Timer;
